<template>
  <header class="site-header">
    <div class="header-inner">
      <router-link class="brand" to="/main" aria-label="返回首頁">
        <img src="@/assets/logo.png" alt="銘成工程有限公司標誌" />
        <span>銘成工程有限公司</span>
      </router-link>

      <button class="menu-toggle" type="button" :aria-expanded="mobileOpen" aria-label="開啟導覽選單" @click="mobileOpen = !mobileOpen">
        <span></span><span></span>
      </button>

      <nav class="site-nav" :class="{ 'is-open': mobileOpen }" aria-label="主選單">
        <router-link
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          class="nav-link"
          active-class="is-active"
          @click="mobileOpen = false"
        >
          {{ item.label }}
        </router-link>
        <a class="nav-cta" href="https://wa.me/67645924" target="_blank" rel="noopener" @click="mobileOpen = false">
          <span>立即諮詢</span>
          <el-icon><ArrowUpRight /></el-icon>
        </a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TopNavbar2',
  data() {
    return {
      mobileOpen: false,
      menuItems: [
        { label: '首頁', path: '/main' },
        { label: '關於我們', path: '/aboutus' },
        { label: '工程能力', path: '/engineering' },
        { label: '項目案例', path: '/projects' },
        { label: '資質服務', path: '/zhizi' },
        { label: '聯絡我們', path: '/contact' },
      ],
    };
  },
};
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid #e6e6e2;
  backdrop-filter: blur(12px);
}

.header-inner {
  width: min(1280px, calc(100% - 64px));
  min-height: 82px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #111111;
  text-decoration: none;
  font-size: 17px;
  font-weight: 700;
  white-space: nowrap;
}

.brand img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

.site-nav {
  display: flex;
  align-items: center;
  gap: clamp(16px, 2.2vw, 34px);
}

.nav-link {
  position: relative;
  padding: 30px 0 27px;
  color: #454545;
  font-size: 14px;
  text-decoration: none;
  white-space: nowrap;
  transition: color 180ms ease;
}

.nav-link::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 19px;
  height: 2px;
  background: #e9b949;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 180ms ease;
}

.nav-link:hover,
.nav-link.is-active {
  color: #111111;
}

.nav-link.is-active::after {
  transform: scaleX(1);
}

.nav-cta {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 42px;
  padding: 0 16px;
  background: #f4c451;
  color: #111111;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  transition: background 180ms ease, transform 180ms ease;
}

.nav-cta:hover {
  background: #e9b949;
  transform: translateY(-1px);
}

.menu-toggle {
  display: none;
  width: 42px;
  height: 42px;
  border: 1px solid #d9d9d4;
  background: #ffffff;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  width: 18px;
  height: 1px;
  margin: 5px auto;
  background: #111111;
}

@media (max-width: 980px) {
  .header-inner {
    width: min(100% - 36px, 760px);
    min-height: 72px;
  }

  .menu-toggle {
    display: block;
  }

  .site-nav {
    position: absolute;
    top: 72px;
    left: 0;
    right: 0;
    display: none;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 8px 18px 18px;
    background: #ffffff;
    border-bottom: 1px solid #e6e6e2;
  }

  .site-nav.is-open {
    display: flex;
  }

  .nav-link {
    padding: 14px 0;
    border-bottom: 1px solid #f0f0ed;
  }

  .nav-link::after {
    bottom: -1px;
    right: auto;
    width: 36px;
  }

  .nav-cta {
    justify-content: center;
    margin-top: 14px;
  }
}

@media (max-width: 520px) {
  .header-inner {
    width: calc(100% - 28px);
  }

  .brand {
    font-size: 15px;
  }
}
</style>
